import Layout from "../../components/Layout";
import AdminCollectionTable from "../../components/AdminCollectionTable";

function formatDate(v) {
  if (!v) return "—";
  const d = new Date(String(v));
  if (isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
}

const COLUMNS = [
  { key: "quote_ref",       label: "Quote Ref",       path: "QuoteRef",        sortable: true, sortPath: "QuoteRef" },
  { key: "status",          label: "Status",          path: "Status",          sortable: true, sortPath: "Status" },
  { key: "created_date",    label: "Created Date",    path: "CreatedDate",     sortable: true, sortPath: "CreatedDate",    formatter: formatDate },
  { key: "account_manager", label: "Account Manager", path: "AccountManager",  sortable: true, sortPath: "AccountManager" },
  { key: "created_by",      label: "Created By",      path: "CreatedBy",       sortable: true, sortPath: "CreatedBy" },
  { key: "expiry_date",     label: "Expiry Date",     path: "ExpiryDate",      sortable: true, sortPath: "ExpiryDate",     formatter: formatDate },
];

export default function QuoteManagement() {
  return (
    <Layout>
      <AdminCollectionTable
        collectionName="quotes"
        title="Quotes"
        subtitle="Quotes created in the Quote Engine."
        columns={COLUMNS}
      />
    </Layout>
  );
}
